import { isAddress } from 'viem';
import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, firstValueFrom, take } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppState } from "../state/app.state";

@Injectable({
    providedIn: 'root'
})
export class TermsGuard  {

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private store: Store<AppState>,
    ) {}
    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        const authState = await firstValueFrom(this.store.select('auth').pipe(
            filter(authState => authState.userData !== null),
        ))
        if (authState.userData.isAnonymous) return true;
        const profileState = await firstValueFrom(this.store.select('profile').pipe(
            filter(profileState => profileState.profileData !== null),
        ))
        if (profileState.profileData.termsAccepted || profileState.termsAcceptedOnRegistration) {
            return true;
        } else {
            const encodedUrl = encodeURIComponent(state.url);
            const url: UrlTree = this.router.parseUrl(`/agree-terms?intendedRoute=${encodedUrl}`);
            return url;
        }
    }
}
